import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import EditRecidencesTips from '../components/layouts/editResidence/EditRecidencesTips'
import { EditResidenceBody } from '../components/layouts/editResidence/EditResidenceBody'
import EditResidenceHeader from '../components/layouts/editResidence/EditResidenceHeader'
import EditResidencescostperday from '../components/layouts/editResidence/EditResidencesCostPerDay'
import EditResidenceSideBar from '../components/layouts/editResidence/EditResidenceSideBar'
import useFetch from '../hooks/useAxios'

const EditResidences = () => {
  const [inforesidencedetail, setinforesidencedetail] = useState() //city //start //end //count
  const {code,slug}=useParams()
  const apiGetresidencedetailInfo = useFetch({
    method: "get",
    url: `api/host/residences/${code}/${slug}`,
    noHeader: false,
    trigger: true,
    argFunc:(res)=>setinforesidencedetail(res.data)
    
   
  });
  const [discountModal, setdiscountModal] = useState(false)
  const [costModal, setcostModal] = useState(false)
  return (
    <div className='EditResidences'>
        <div>
          <EditResidenceSideBar setdiscountModal={setdiscountModal} setcostModal={setcostModal} />
        </div>
        <div className='EditResidences--Container'>
       <EditResidenceHeader/>
          {inforesidencedetail&&<EditResidenceBody inforesidencedetail={inforesidencedetail}/>}
        </div>
      { discountModal && <EditRecidencesTips closeModal={()=>setdiscountModal(false)} /> }
      { costModal && <EditResidencescostperday closeModal={()=>setcostModal(false)} /> }
    </div>
  )
}

export default EditResidences